import PropTypes from 'prop-types';
import React, { Component } from 'react';
import styled from 'styled-components';
import classnames from 'classnames';

import { color as themeColor } from '../../theme';

const Children = styled.div`
  margin-left: 40px;
`;

const Element = styled.div`
  ${(props) => (props.inline ? 'margin-right: 40px;' : '')}
  opacity: ${(props) => (props.disabled ? '0.5' : '1')};
`;

const ButtonWrapper = styled.div`
  display: flex;
  cursor: inherit;
`;

const Svg = styled.svg`
  display: inline-block;
  fill: ${(props) => props.color || themeColor.primary};
  height: 24px;
  margin-top: -12px;
  opacity: 1;
  position: absolute;
  top: 50%;
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  user-select: none;
  width: 24px;
`;

const Input = styled.input`
  &&& {
    margin: 0;
  }

  box-sizing: border-box;
  height: 100%;
  left: 0;
  opacity: 0;
  padding: 0;
  pointer-events: all;
  position: absolute;
  width: 100%;
`;

const Label = styled.label`
  color: ${themeColor.primary};
  display: block;
  float: left;
  font-family: Roboto, sans-serif;
  line-height: 24px;
  position: relative;
  width: calc(100% - 60px);
`;

const RadioButtonChecked = () => (
  <path
    d="M12 7c-2.76 0-5 2.24-5 5s2.24 5 5 5 5-2.24 5-5-2.24-5-5-5zm0-5C6.48 2 2 6.48 2 12s4.48 10
   10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
  />
);

const RadioButtonUnchecked = () => (
  <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z" />
);

const RadioButtonWrapper = styled.div`
  cursor: ${(props) => (props.disabled ? 'not-allowed' : 'pointer')};
  margin-right: 16px;
  transition: all 450ms cubic-bezier(0.23, 1, 0.32, 1) 0ms;
  vertical-align: middle;
  width: 24px;
`;

export default class RadioButton extends Component {
  static propTypes = {
    color: PropTypes.string,
    disabled: PropTypes.bool,
    inline: PropTypes.bool,
    isChecked: PropTypes.bool.isRequired,
    label: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    name: PropTypes.string,
    check: PropTypes.func,
    value: PropTypes.any.isRequired,
  };

  static defaultProps = {
    disabled: false,
    inline: false,
    isChecked: false,
  };

  handleOnClick = () => {
    const { disabled, check, value } = this.props;
    !disabled && check && check(value);
  };

  render() {
    const { children, color, disabled, inline, isChecked, label, name, value, ...rest } = this.props;
    const RadioElement = isChecked ? RadioButtonChecked : RadioButtonUnchecked;

    return (
      <Element
        {...rest}
        className={classnames('radio-button', {
          'radio-button--is-checked': isChecked,
        })}
        inline={inline}
        disabled={disabled}
      >
        <div style={{ position: 'relative' }}>
          <Input
            id={`${name}-${value}`}
            type="radio"
            name={name}
            value={value}
            onChange={this.handleOnClick}
            disabled={disabled}
          />

          <ButtonWrapper onClick={this.handleOnClick}>
            <RadioButtonWrapper disabled={disabled}>
              <Svg viewBox="0 0 24 24" color={isChecked ? color : 'black'}>
                <RadioElement />
              </Svg>
            </RadioButtonWrapper>
            <Label className="radio-button__label" htmlFor={`${name}-${value}`}>
              {label}
            </Label>
          </ButtonWrapper>
        </div>
        {children && <Children>{children}</Children>}
      </Element>
    );
  }
}
